<template>
	<button :type="eltag" :class="[btnType,{'btn-unbg':!!unbg,'btn-border':!!border,'btn-block':!!block},btnSize]" class="btn" @click="handleClick">
		<span v-if="!!icon" :class="[icon]" class="iconfont"></span>
		<slot></slot>
	</button>
</template>

<script>
	export default {
		name: 'bsf-btn',
		components: {},
		props: {
			eltag: {
				type: String,
				default: "button"
			},
			btype: {
				type: String,
				default: 'default'
			},
			unbg: {
				type: Boolean,
				default: false
			},
			border: {
				type: Boolean,
			},
			size: {
				type: String,
				default: ""
			},
			block: {
				type: Boolean,
			},
			icon: {
				type: [String, Array],
			}
		},
		data() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		methods: {
			handleClick(evt) {
				this.$emit('click', evt);
			}
		},
		computed: {
			btnType: function() {
				return 'btn-' + this.btype
			},
			btnSize: function() {
				return this.size ? ('btn-' + this.size) : ''
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	@import "../../../assets/lib/btn.less";
</style>


// WEBPACK FOOTER //
// btn.vue?1df10ac0